import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'sanitizeHtml',
})
export class SanitizeHtmlPipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (this.isBase64(value)) {
      value = atob(value);
    }
    if (this.isURLEncoded(value)) {
      value = decodeURIComponent(value);
    }

    const sanitizedContent = DOMPurify.sanitize(value, {
      FORBID_TAGS: ['script'],
      FORBID_ATTR: ['onerror', 'onclick', 'onload', 'onmouseover'],
    });

    return this._sanitizer.bypassSecurityTrustHtml(sanitizedContent);
  }

  /**
   * The isBase64 method is designed to check whether a given string is a valid base64-encoded string.
   * It performs validation by checking the format and attempting to decode the string.
   * Parameters: str (string): The input string that needs to be checked for base64 encoding.
   * Returns: boolean: Returns true if the string is a valid base64-encoded string, and false otherwise.
   */
  private isBase64(str: string): boolean {
    if (str === undefined || str.length % 4 !== 0) {
      return false;
    }
    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
    if (!base64Regex.test(str)) {
      return false;
    }
    try {
      atob(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * Check if a string is a valid URL encoded string
   */
  private isURLEncoded(str: string): boolean {
    return decodeURIComponent(str) !== str;
  }
}
